import { resolveAdminNavModule } from "./adminModules";

/** @deprecated Use resolveAdminNavModule */
export function resolveAdminNavFeature(route) {
    return resolveAdminNavModule(route);
}

export function isRouteModuleVisible(route, isModuleEnabled, mode) {
    if (mode !== "admin-only") return true;
    const moduleId = resolveAdminNavModule(route);
    if (!moduleId) return true;
    return isModuleEnabled(moduleId);
}

export function isModuleSectionVisible(moduleId, isModuleEnabled, mode) {
    if (mode !== "admin-only") return true;
    if (!moduleId) return true;
    return isModuleEnabled(moduleId);
}

export function filterDashboardLinks(links, isModuleEnabled, mode) {
    return links.filter((link) => isRouteModuleVisible(link.to, isModuleEnabled, mode));
}

export function filterChecklistItems(items, isModuleEnabled, mode) {
    return items.filter((item) => isRouteModuleVisible(item.to, isModuleEnabled, mode));
}
